import { Controller } from "@hotwired/stimulus"

import DrawerController from "@/controllers/drawer_controller"
import { type DispatchEvent } from "@/entry_points/types"

export default class extends Controller {
  static outlets = ["drawer"]
  declare readonly drawerOutlets: DrawerController[]

  closeOthers({ detail }: DispatchEvent<{ drawer: DrawerController }>): void {
    this.drawerOutlets.forEach((drawer) => {
      if (drawer !== detail.drawer) {
        drawer.close()
      }
    })
  }
}
